import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=26e1d20c&"
import script from "./PaymentsView.vue?vue&type=script&lang=js&"
export * from "./PaymentsView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsView.vue?vue&type=style&index=0&id=26e1d20c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports